export default "__VITE_ASSET__DEs8O3NN__"